import PropTypes from 'prop-types';

const Sidebar = ({ children }) => (
  <aside
    className="peer flex h-auto w-full flex-col gap-y-6 px-4 lg:col-span-4 lg:col-start-13 lg:max-w-80 lg:px-0 xl:h-fit"
    data-sidebar
  >
    {children}
  </aside>
);

Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Sidebar;
